// Libraries.
//import pace from 'pace-progress';
// import picturefill from 'picturefill';
import svg4everybody from 'svg4everybody';

// Modules.
import { init as lazyLoad } from './modules/lazyload';
import 'owl.carousel';
import 'jquery';
// import masonry from './modules/masonry';

// Components.

import accordion from './components/accordion';
import consent from './components/consent';
import background from './components/background';
import dropdown from './components/dropdown';
import modalSensitive from './components/modal-sensitive';
import filters from './components/filters';
import jumpers from './components/jumpers';
import modal from './components/modal';
import navToggle from './components/nav-toggle';
import scrolling from './components/scrolling';
import slider from './components/slider';

function init() {

  // Libraries.
  svg4everybody();

  // Modules.
  lazyLoad();

  // Components.
  accordion();
  background();
  consent();
  dropdown();
  modalSensitive();
  filters();
  jumpers();
  modal();
  navToggle();
  scrolling();
  slider();

  // window.$ = $;
  // window.jQuery = jQuery;

}

export default init;
